import Type from "@/model/types/Type";

const type = {
    CUSTOMER: 1,
    GROUP_CUSTOMER: 2,
    PRODUCT: 3,
    OTHER: 20,
}

const list = [
    {
        value: type.CUSTOMER,
        text: "Cliente",
    },
    {
        value: type.GROUP_CUSTOMER,
        text: "Grupo de Cliente",
    },
    {
        value: type.PRODUCT,
        text: "Produto",
    },
    {
        value: type.OTHER,
        text: "Outros",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}